import { ReactElement } from "react";

import { useDynamicFormsUtils, useTableFiltersActions } from "@ryde/redux";

import { NumberComparisonFilterField } from "./parts/number-comparison-filter-field";

interface IFilterNumberComparison {
  customFieldId: number;
  value: string[] | null;
}

/**
 * Grid wiring for the shared number-comparison filter field: the grid addresses a filter by its custom
 * field id and labels it from the dynamic-forms control, where the reports bar uses a template key.
 */
export const FilterNumberComparison = ({
  customFieldId,
  value,
}: IFilterNumberComparison): ReactElement => {
  const { getGridControlLabelById } = useDynamicFormsUtils();
  const { setValuesToFilter, handleRemoveFilter } = useTableFiltersActions();
  const label = customFieldId ? getGridControlLabelById(customFieldId) : "";

  const onApply = (encodedValue: string | undefined): void => {
    setValuesToFilter(customFieldId, encodedValue ? [encodedValue] : []);
  };

  const onRemove = (): void => {
    handleRemoveFilter(customFieldId);
  };

  return (
    <NumberComparisonFilterField
      fieldId={label}
      label={label}
      value={value}
      onApply={onApply}
      onRemove={onRemove}
    />
  );
};
